import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { t } from '../../lib/i18n';
import { WyrdMakerLogo } from '../ui/WyrdMakerLogo';

export function Footer() {
  const { language } = useAuth();

  const productLinks = [
    { label: t('nav_features', language), to: '/features' },
    { label: t('nav_pricing', language), to: '/pricing' },
    { label: t('nav_updates', language), to: '/updates' },
  ];

  const supportLinks = [
    { label: t('nav_help', language), to: '/help' },
    { label: t('nav_contact', language), to: '/contact' },
  ];

  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center mb-3 hover:opacity-90 transition-opacity">
              <WyrdMakerLogo size="sm" showText={true} />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t('footer_tagline', language)}
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-cinzel font-bold text-sm mb-4">{t('footer_product', language)}</h4>
            <ul className="space-y-2.5">
              {productLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-cinzel font-bold text-sm mb-4">{t('footer_support', language)}</h4>
            <ul className="space-y-2.5">
              {supportLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-cinzel font-bold text-sm mb-4">{t('footer_legal', language)}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {language === 'fr' ? 'Mentions légales' : 'Legal Notice'}
                </Link>
              </li>
              <li>
                <Link
                  to="/cgu"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {language === 'fr' ? "CGU" : 'Terms of Use'}
                </Link>
              </li>
              <li>
                <Link
                  to="/cgv"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {language === 'fr' ? 'CGV' : 'Terms of Sale'}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} {t('app_name', language)}. {t('footer_copyright', language)}
          </p>
        </div>
      </div>
    </footer>
  );
}
